'use client';

import React, { useEffect } from 'react';
import Link from 'next/link';
import styles from './styles.module.css';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import FloatingSection from './components/FloatingSection';
import useMediaQuery from '../hooks/useMediaQuery';
import { useSpring, animated, config } from '@react-spring/web';

function Landing() {
  const router = useRouter();
  const { isMobile } = useMediaQuery();

  /* Optional - Press any key to continue effect */
  useEffect(() => {
    const handleKeyPress = (event) => {
      router.push('/signin');
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [router]);

  const fadeInSpring = useSpring({
    from: { opacity: 0, transform: 'scale(0.8)' },
    to: { opacity: 1, transform: 'scale(1)' },
    config: config.gentle,
  });

  return (
    <div className={styles.main}>
      <animated.div style={fadeInSpring} className={styles.wrapper}>
        {!isMobile ? <FloatingSection /> : null}
        <div className={styles.title}>
          <div>
            <Image
              className={styles.logo}
              src={'/img/logo-black.png'}
              alt="Logo"
              width={600}
              height={600}
            />
          </div>
          <Link href={'/signin'}>
            {isMobile ? 'Continue to Auth' : 'Press Any Key to Continue'}
          </Link>
        </div>
      </animated.div>
    </div>
  );
}

export default Landing;
